(() => {
  if (window.diGarmentsReady) return;
  window.diGarmentsReady = true;
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-di-garment-view]');
    if (!button) return;
    const card = button.closest('[data-di-garment]');
    if (!card) return;
    const view = button.dataset.diGarmentView;
    if (view !== 'primary' && view !== 'secondary') return;
    card.dataset.diView = view;
    card.querySelectorAll('[data-di-garment-view]').forEach(control => {
      control.setAttribute('aria-pressed', String(control.dataset.diGarmentView === view));
    });
    card.querySelectorAll('[data-di-garment-layer]').forEach(layer => {
      layer.setAttribute('aria-hidden', String(layer.dataset.diGarmentLayer !== view));
    });
  });
})();
